<template>
  <div class="layer-popup-overlay" :class="visible ? 'show' : ''" @click.self="close">
    <div class="layer-popup">
      <button class="close-btn" @click="close"></button>
      <slot />
    </div>
  </div>
</template>

<script setup>
import { ref, defineExpose, defineEmits } from 'vue'

const visible = ref(false)

function open() {
  visible.value = true
}

function close() {
  visible.value = false
  emit('onClose')
}

defineExpose({ open, close })
const emit = defineEmits(['onClose'])
</script>

<style scoped>
.layer-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.layer-popup-overlay {
  visibility: hidden;
}
.layer-popup-overlay.show {
  visibility: visible;
  animation: fadeIn 0.1s ease-in;
}
.layer-popup {
  background: #000;
  position: relative;
  width: var(--contents-width);
  max-width: var(--max-contents-width);
  height: auto;
  max-height: calc(100svh * 0.85); /* svh 단위만 사용 (vh 단위 중복 제거) */
  line-height: 0;
  overflow: hidden;
  animation: fadeIn 0.5s ease-in;
}
.close-btn {
  position: absolute;
  top: 1.2rem;
  right: 1.2rem;
  background: transparent;
  border: none;
  width: 1.8rem;
  height: 1.8rem;
  cursor: pointer;
  background-image: url('@/assets/2025/images/02_btn_x.png');
  background-size: contain;
  background-repeat: no-repeat;
}

.video-popup .layer-popup {
  display: flex;
  align-items: center;
  width: var(--contents-width);
  max-width: var(--max-contents-width);
  min-height: 100vh;
  min-height: 100svh;
}
.video-popup .layer-popup .close-btn {
  background-image: url('@/assets/2025/images/03_btn_x.png');
  top: calc(100svh * 0.08); /* svh 단위만 사용 (vh 단위 중복 제거) */
}

.new-product-popup .layer-popup {
  height: 100svh; /* svh 단위만 사용 (vh 단위 중복 제거) */
  max-height: none;
}

@media (min-width: 640px) {
  .layer-popup {
    border-radius: 8px;
    width: auto;
    max-width: calc(var(--desktop-contents-width) * 0.95);
    min-height: var(--desktop-contents-height);
  }
  .video-popup .layer-popup {
    width: 95%; /* 너비를 좀 더 크게 확장 */
    max-width: 1600px; /* 최대 너비 증가 */
    height: auto; /* 높이를 콘텐츠에 맞게 자동 조정 */
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0; /* 패딩 제거 */
  }
  .video-popup .layer-popup .close-btn {
    top: 1.2rem;
  }
  .close-btn {
    top: 1.2rem;
    right: 1.2rem;
  }
  .new-product-popup .layer-popup {
    height: inherit;
    max-width: var(--desktop-contents-width);
    max-height: 100svh; /* svh 단위만 사용 (vh 단위 중복 제거) */
    border-radius: 0px;
  }
}
</style>
